import React from 'react'

import { getTranslation } from 'utils/translations'

const NewProductFlag = () => (
  <span className="new-product-flag">{getTranslation('shared.products.newProduct')}</span>
)

export default NewProductFlag
